// ============================================================
// fondos/efectos/particles.js — «Partículas»: motas que suben, oscilan y parpadean (efecto de LIENZO)
//
// Portado de `vendor/bg/particles-bg.js` en la F2b del P3 con el MISMO dibujo (el test de espejo lo
// compara llamada a llamada con la clase de siempre). La velocidad va por `dt` (`comun.js::PASO`) y
// el puntero llega desde la SECCIÓN (`fondos/lienzo.js`): las partículas se apartan del ratón, que
// hasta ahora nunca llegaba (E12).
//
// F3 (E13): el alfa sale del tope del catálogo (`alfaMax`) y sobre CLARO las motas crecen
// (`comun.js::TAM_CLARO`): sobre claro casi no se veían. En oscuro, el dibujo de siempre.
// ============================================================

import { pasos, rgbDe, interpolar, tamano } from './comun.js';

/** Radio (px CSS) dentro del cual el puntero aparta las partículas. */
const REPELE = 100;

export default {
    crear(ctx, e) {
        const p = e.params;
        const speedMult = p.speed != null ? (0.4 + (p.speed - 1) * (2.6 / 9)) : 1.0;
        // Densidad 1-10 → 25-120 partículas (15-60 en táctil).
        const n = Math.round(interpolar(p.density, 5, e.tactil ? 15 : 25, e.tactil ? 60 : 120));
        const particulas = [];
        for (let i = 0; i < n; i++) {
            particulas.push({
                x: e.azar(),
                y: e.azar(),
                vx: (e.azar() - 0.5) * 0.3 * speedMult,
                vy: (-e.azar() * 0.5 - 0.2) * speedMult,
                size: e.azar() * 2 + 1,
                alphaOffset: e.azar() * Math.PI * 2,
            });
        }
        return { w: e.w, h: e.h, rgb: rgbDe(e.c1), alfa: e.alfa, tam: tamano(e.oscuro), particulas: particulas };
    },

    redimensionar(s, w, h) {
        s.w = w;
        s.h = h;
    },

    dibujar(s, ctx, t, dt, puntero) {
        const k = pasos(dt);
        const rgb = s.rgb;
        const W = s.w;
        const H = s.h;
        const time = t * 0.001;

        s.particulas.forEach(function (p) {
            // Un fotograma quieto (dt 0) repinta el estado tal cual.
            if (k > 0) {
                let px = p.x * W;
                let py = p.y * H;
                if (puntero && puntero.x > 0) {
                    const dx = px - puntero.x;
                    const dy = py - puntero.y;
                    const dist = Math.hypot(dx, dy);
                    if (dist < REPELE && dist > 0) {
                        const force = (REPELE - dist) / REPELE;
                        px += (dx / dist) * force * 5 * k;
                        py += (dy / dist) * force * 5 * k;
                    }
                }
                p.x = px / W + (p.vx * k / W);
                p.y = py / H + (p.vy * k / H);
                // Deriva lateral suave.
                p.x += Math.sin(time + p.alphaOffset) * 0.0005 * k;
                // Salen por arriba y vuelven por abajo; por los lados, por el lado contrario.
                if (p.y < -0.1) p.y = 1.1;
                if (p.x < -0.1) p.x = 1.1;
                if (p.x > 1.1) p.x = -0.1;
            }

            const flicker = Math.sin(time * 2 + p.alphaOffset) * 0.5 + 0.5;
            const alpha = s.alfa * (0.5 + 0.5 * flicker);
            ctx.fillStyle = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
            ctx.beginPath();
            ctx.arc(p.x * W, p.y * H, p.size * s.tam, 0, Math.PI * 2);
            ctx.fill();
        });
    },
};
